module.exports = __webpack_public_path__ + "img/upgrader.e880ae15.jpeg";